"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.plotBookmark = exports.loadBookmarks = exports.persistBookmark = exports.deleteSessionBookmark = exports.BOOKMARKS_LOAD_SUCCESS = exports.BOOKMARK_SAVED = void 0;

var _actions = require("kmap-redux/dist/actions");

var _kubraKmap = _interopRequireDefault(require("kubra-kmap"));

var _mapActions = require("./mapActions");

var _infoboxActions = require("./infoboxActions");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var BOOKMARK_SAVED = 'BOOKMARK_SAVED';
exports.BOOKMARK_SAVED = BOOKMARK_SAVED;
var BOOKMARKS_LOAD_SUCCESS = 'BOOKMARKS_LOAD_SUCCESS';
exports.BOOKMARKS_LOAD_SUCCESS = BOOKMARKS_LOAD_SUCCESS;

var deleteSessionBookmark = function deleteSessionBookmark(bookmark) {
  return function (dispatch) {
    var existingBookmarksRaw = window.localStorage.getItem('bookmarks');

    if (existingBookmarksRaw) {
      var bookmarkArray = JSON.parse(existingBookmarksRaw);
      var filteredBookmarkArray = bookmarkArray.filter(function (e) {
        return e.address !== bookmark.address;
      });
      window.localStorage.setItem('bookmarks', JSON.stringify(filteredBookmarkArray));
      dispatch({
        type: BOOKMARK_SAVED,
        bookmarks: filteredBookmarkArray
      });
    }
  };
};

exports.deleteSessionBookmark = deleteSessionBookmark;

var persistBookmark = function persistBookmark(bookmark) {
  return function (dispatch) {
    var existingBookmarksRaw = window.localStorage.getItem('bookmarks');
    var persistingBookmark = Object.assign({}, _objectSpread(_objectSpread({}, bookmark), {}, {
      bookmarked: true
    }));

    if (!existingBookmarksRaw) {
      var bookmarkArray = [];
      bookmarkArray.push(persistingBookmark);
      window.localStorage.setItem('bookmarks', JSON.stringify(bookmarkArray));
      dispatch({
        type: BOOKMARK_SAVED,
        bookmarks: bookmarkArray
      });
    } else {
      var _bookmarkArray = JSON.parse(existingBookmarksRaw);

      var existingIndex = _bookmarkArray.findIndex(function (currentBookmark) {
        return currentBookmark.address === persistingBookmark.address;
      });

      if (existingIndex === -1) {
        _bookmarkArray.push(persistingBookmark);
      } else {
        _bookmarkArray[existingIndex] = persistingBookmark;
      }

      window.localStorage.setItem('bookmarks', JSON.stringify(_bookmarkArray));
      dispatch({
        type: BOOKMARK_SAVED,
        bookmarks: _bookmarkArray
      });
    }
  };
};

exports.persistBookmark = persistBookmark;

var loadBookmarks = function loadBookmarks() {
  return function (dispatch) {
    var existingBookmarksRaw = window.localStorage.getItem('bookmarks');

    if (!existingBookmarksRaw) {
      dispatch({
        type: BOOKMARKS_LOAD_SUCCESS,
        bookmarks: []
      });
    } else {
      dispatch({
        type: BOOKMARKS_LOAD_SUCCESS,
        bookmarks: JSON.parse(existingBookmarksRaw)
      });
    }
  };
};

exports.loadBookmarks = loadBookmarks;

var plotBookmark = function plotBookmark(bookmark) {
  return function (dispatch) {
    dispatch((0, _actions.deleteAllSpecialMarkers)());
    dispatch((0, _mapActions.clearSelectedIcon)());
    dispatch((0, _actions.goToPoint)(bookmark.view, _kubraKmap.default.specialMarker.BOOKMARK, {}, function (point) {
      point.on('click', function () {
        dispatch((0, _actions.removeSelected)());
        var geom = {
          points: [[[bookmark.view.center.lat, bookmark.view.center.lng]]]
        };
        dispatch((0, _actions.selectElement)(geom, _kubraKmap.default.geometryTypes.POINT));
        dispatch({
          type: _infoboxActions.INFOBOX_SELECT_ADDRESS,
          address: bookmark
        });
      });
    }));
  };
};

exports.plotBookmark = plotBookmark;